import CognitoAccount from "./cognito-account";
import Discipline from "./discipline";
import HealthDetail from "./health-detail";

export default class EmployeeDetail {
  payrollId: string;
  hireDate: string;
  employeeAltId: string;
  driversLicenseNumber: string;
  driversLicenseExpiration: string;
  jobRoleDetails: {
    employmentStatus: string;
    department: string;
    position: string;
    disciplines: Discipline[];
  };
  healthDetails: HealthDetail[];
  employeeAccount?: CognitoAccount;
}



// WEBPACK FOOTER //
// ./src/models/company-resources/employee-detail.ts